import { useState } from "react";
import MyModal from "../../../Common/my-modal/my-modal.component";
import ModalForm from "./modal-form";

interface ResetPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<void> | void;
}

const ResetPasswordModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ResetPasswordModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!onConfirm) {
      onClose();
      return;
    }

    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error("Error resetting password:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MyModal show={isOpen} onHide={onClose}>
      <MyModal.Header
        closeButton
        onCrossClick={onClose}
        className="border-bottom"
      >
        <MyModal.HeaderTitle className="text-align-center w-100">
          Reset Password
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <ModalForm onClose={onClose} onConfirm={handleConfirm} loading={loading} />
    </MyModal>
  );
};

export default ResetPasswordModal;

